import { SupText } from "@repo/core-ui";
import { SupSource, SupVaultUser } from "@repo/core-ui";
import React from "react";
import { Icons } from "../../UI/Icon";

interface CardItem {
  icon: string | React.ReactElement;
  title: string;
  items: string[];
}

function Card({ icon, title, items }: CardItem) {
  return (
    <div className="flex w-full flex-col overflow-hidden rounded-3xl rounded-tr-none border-0.5 border-primary-600">
      <div className="flex">
        <div className="bg-primary-200/80 p-4">{icon}</div>
        <div className="grow bg-primary-100 p-4">
          <SupText className="" family="mono" variant="body1" weight="bold">
            {title}
          </SupText>
        </div>
      </div>
      <ul className="flex-grow  bg-neutral-75/20 px-4 pb-8 pt-4">
        {items.map((item: string, index: number) => (
          <li key={index} className="flex items-baseline leading-tight">
            <span className="mr-2">•</span>
            <SupText className="text-[14px]" variant="body1" family="mono">
              {item}
            </SupText>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function CardsLayout() {
  const cardsData: CardItem[] = [
    {
      icon: <SupVaultUser />,
      title: "DEPOSIT",
      items: ["More TVL, more CRED.", "All deposits earn 10x CRED boost.", "Supervaults earn 20x CRED boost."],
    },
    {
      icon: <Icons.star className="h-5 w-5" />,
      title: "BOOST",
      items: ["Boosts multiply CRED. All boosts stack.", "Boost by ranking on the TVL leaderboard.", "Boost by owning an entire tier of Season One SuperFren NFTs."],
    },
    {
      icon: <SupSource />,
      title: "REFER",
      items: ["Direct referrals earn you 10% of their CRED.", "Second-degree referrals earn you 1% of their CRED."],
    },
  ];

  return (
    <div className="flex flex-col space-y-4 md:flex-row md:space-x-8 md:space-y-0">
      {cardsData.map((card, index) => (
        <Card key={index} {...card} />
      ))}
    </div>
  );
}
